import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";
import MultiSelectDropdown from "../../../../Base/Components/Form/MultiSelectDropdown";

import { EditarAspirante, getIdiomas, getIdiomasPorId, GuardarAspirante } from "../../../../API/RRHH/Maestros/MaestrosRequest";
import { getSexos } from "../../../../API/RRHH/Personal/PersonalRequest";


const CandidatosCRUD = ({ showDialog, setShowDialog, getInfo, selected, setSelected, modo, editable = true }) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [monedas, setMonedas] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [selectedIdiomas, setSelectedIdiomas] = useState([]);
  

  const initialValues = {
    IdAspirante: -1,
    SalarioMinimo: false,
    HorasExtra: false,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const monedasTempo = await ObtenerCurrency("General");
    setMonedas(monedasTempo);

    const generosTempo = await getSexos()
    setGeneros(generosTempo)


    const idiomasTempo = await getIdiomas()
    setIdiomas(idiomasTempo)
    
    if(selected[0]?.IdAspirante > 0){
      const idiomasSeleccionados = await getIdiomasPorId(selected[0]?.IdIdiomas)
      setSelectedIdiomas(idiomasSeleccionados)
      setValues({
        ...selected[0],
        FechaNacimiento: new Date(selected[0]?.FechaNacimiento),
      });
    }else{
      setValues(initialValues);
    }

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    getInfo()
    setSelected([])
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Nombres) {
      error.Nombres = true;
      error.error = true;
    }
    if (!values.Apellidos) {
        error.Apellidos = true;
        error.error = true;
    }
    if (!values.Identidad) {
        error.Identidad = true;
        error.error = true;
    }
    if (!values.Telefono) {
        error.Telefono = true;
        error.error = true;
    }
    if (!values.Correo) {
        error.Correo = true;
        error.error = true;
    }
    if (!values.Direccion) {
        error.Direccion = true;
        error.error = true;
    }
    if (!values.FechaNacimiento) {
        error.FechaNacimiento = true;
        error.error = true;
    }
    if (!values.Genero?.IdSexo && !values?.IdSexo) {
        error.IdSexo = true;
        error.error = true;
    }
    // if(selectedIdiomas.length <= 0){
    //     error.selectedIdiomas = true;
    //     error.error = true;
    // }
    if (!values.GradoAcademico) {
        error.GradoAcademico = true;
        error.error = true;
    }
    if (!values.Experiencia) {
        error.Experiencia = true;
        error.error = true;
    }
    if (!values.AniosExperiencia) {
        error.AniosExperiencia = true;
        error.error = true;
    }
    if (!values.UltimoTrabajo) {
        error.UltimoTrabajo = true;
        error.error = true;
    }
    if(!values?.SalarioMinimo){
        if (!values.AspiracionSalarial) {
            error.AspiracionSalarial = true;
            error.error = true;
        }
    }

    setError(error);
    return error;
  };

  const agregarAspirante = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const Datos = {
        IdAspirante: selected[0]?.IdAspirante ? selected[0]?.IdAspirante : -10,
        Nombres: values?.Nombres,
        Apellidos: values?.Apellidos,
        Identidad: values?.Identidad,
        Telefono: values?.Telefono,
        Correo: values?.Correo,
        Direccion: values?.Direccion,
        FechaNacimiento: values?.FechaNacimiento,
        IdSexo: values?.Genero?.IdSexo || values?.IdSexo,
        IdIdiomas: selectedIdiomas.map(i => i.IdIdioma).join(","),
        GradoAcademico: values?.GradoAcademico,
        Experiencia: values?.Experiencia,
        AniosExperiencia: values?.AniosExperiencia,
        UltimoTrabajo: values?.UltimoTrabajo,
        Comentarios: values.Comentarios,
        SalarioMinimo: values.SalarioMinimo,
        HorasExtra: values.HorasExtra,
        AspiracionSalarial: values.AspiracionSalarial,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      if(Datos.IdAspirante > 0){
        setLoading(true)
        const resultado = await EditarAspirante(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow(toast,"success","Datos Editados",resultado[0]?.MENSAJE );
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }else{
        const resultado = await GuardarAspirante(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Editar"}
        icon="pi pi-check"
        className="p-button-text"
        disabled={!editable}
        onClick={() => {agregarAspirante();}}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Candidato" : "Editar Candidato";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: '50%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div>
            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Nombres"
                    value={values.Nombres}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Nombres ? "p-invalid" : ""}
                  />
                  <label htmlFor="Nombres">Nombre</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Apellidos"
                    value={values.Apellidos}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Apellidos ? "p-invalid" : ""}
                  />
                  <label htmlFor="Apellidos">Apellido</label>
                </span>
              </div>

            </div>

            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Identidad"
                    value={values.Identidad}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Identidad ? "p-invalid" : ""}
                  />
                  <label htmlFor="Identidad">Identificación</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Telefono"
                    value={values.Telefono}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Telefono ? "p-invalid" : ""}
                  />
                  <label htmlFor="Telefono">Teléfono</label>
                </span>
              </div>

            </div>

            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Correo"
                    value={values.Correo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Correo ? "p-invalid" : ""}
                  />
                  <label htmlFor="Correo">Correo</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Direccion"
                    value={values.Direccion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Direccion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Direccion">Dirección</label>
                </span>
              </div>

            </div>

            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                    <Calendar
                      id="FechaNacimiento"
                      name="FechaNacimiento"
                      value={values?.FechaNacimiento}
                      dateFormat="dd/mm/yy"
                      style={{width: '100%'}}
                      mask="99/99/9999"
                      onChange={(e) => handleInputChange(e, "FechaNacimiento")}
                      showIcon
                      maxDate={new Date(2010, 11, 31)}
                      className={error.FechaNacimiento ? "p-invalid" : ""}
                    />
                    <label htmlFor="FechaNacimiento">Fecha de Nacimiento</label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"Genero"}
                        value={values.Genero}
                        items={generos}
                        field={"Sexo"}
                        label={"Género"}
                        handleInputChange={handleInputChange}
                        className={error.IdSexo ? "p-invalid" : ""}
                    />
                    </span>
                </div>
            </div>

            <div className="d-flex mx-4">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                    <MultiSelectDropdown
                        name="Idioma"
                        value={selectedIdiomas}
                        setValue={setSelectedIdiomas}
                        items={idiomas}
                        field="Idioma"
                        placeholder="Seleccione Idioma"
                        label="Idioma"
                    />
                    </span>
                </div>

                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputText
                            name="GradoAcademico"
                            value={values.GradoAcademico}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.GradoAcademico ? "p-invalid" : ""}
                        />
                        <label htmlFor="GradoAcademico">Grado Académico</label>
                    </span>
                </div>

            </div>

            <div className="d-flex mx-4">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputText
                            name="Experiencia"
                            value={values.Experiencia}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Experiencia ? "p-invalid" : ""}
                        />
                        <label htmlFor="Experiencia">Experiencia</label>
                    </span>
                </div>

                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputNumber
                            name="AniosExperiencia"
                            value={values.AniosExperiencia}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            minFractionDigits={2}
                            className={error.AniosExperiencia ? "p-invalid" : ""}
                        />
                        <label htmlFor="AniosExperiencia">Años de Experiencia</label>
                    </span>
                </div>

            </div>

            <div className="d-flex mx-4">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputText
                            name="UltimoTrabajo"
                            value={values.UltimoTrabajo}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.UltimoTrabajo ? "p-invalid" : ""}
                        />
                        <label htmlFor="UltimoTrabajo">Ultimo Trabajo</label>
                    </span>
                </div>

                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputText
                            name="Comentarios"
                            value={values.Comentarios}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Comentarios ? "p-invalid" : ""}
                        />
                        <label htmlFor="Comentarios">Comentarios</label>
                    </span>
                </div>
            </div>

            <div className="d-flex mx-4">
                <div className="field col-3 mt-4">
                  <span className="mx-2 mt-4">Salario Mínimo</span>
                  <Checkbox
                    id="SalarioMinimo"
                    name="SalarioMinimo"
                    checked={values.SalarioMinimo}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="field col-3 mt-4">
                    <span className="mx-2 mt-4">Horas Extra</span>
                    <Checkbox
                        id="HorasExtra"
                        name="HorasExtra"
                        checked={values.HorasExtra}
                        onChange={handleInputChange}
                    />
                </div>


                <div className="field col-6 mx-2 mt-2">
                    <span className="p-float-label">
                        <InputNumber
                            name="AspiracionSalarial"
                            value={values.AspiracionSalarial}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            minFractionDigits={2}
                            disabled={values?.SalarioMinimo === true}
                            className={error.AspiracionSalarial ? "p-invalid" : ""}
                        />
                        <label htmlFor="AspiracionSalarial">Aspiración Salarial</label>
                    </span>
                </div>
            </div>

          </div>
        </div>
      </Dialog>

      
    </div>
  );
};

export default CandidatosCRUD;
